export const privateLabel = {
  hero: {
    title: "Private Label Solutions",
    subtitle: "Your Brand, Our Expertise",
    discreet: "DISCREET.",
    precise:"PRECISE.",
    exclusive:"EXCLUSIVE."
  },
  intro: {
    title: "Partner with Excellence",
    description: "Transform your vision into reality with our comprehensive private label services. We combine decades of expertise with state-of-the-art facilities to create premium coffee and beverage products under your brand."
  },
  features: {
    quality: {
      title: "Consistency in Quality",
      description: "At Lucendo, consistency in quality is not a promise—it is our discipline. Every product, every process, and every detail reflects an unwavering commitment to excellence, guided by rigorous standards and refined craftsmanship. From concept to completion, we apply the same precision, care, and integrity to ensure results that are reliable, enduring, and worthy of trust. This steadfast consistency is what defines Lucendo, elevates our work, and delivers lasting value to those who choose us."
    },
    transparency: {
      title: "Transparency",
      description: "At Lucendo, transparency is the foundation of every partnership we build. We believe trust is earned through open communication, clear expectations, and honesty at every stage of collaboration. By sharing insights, decisions, and progress without ambiguity, we create partnerships grounded in mutual respect and confidence. This commitment to transparency ensures alignment, strengthens relationships, and allows us to grow together with clarity, integrity, and shared success."
    },
    growth: {
      title: "Sustainable Growth",
      description: "At Lucendo, sustainable growth is driven by purposeful decisions and long-term vision. We balance innovation with responsibility, building strategies that create enduring value for our partners, our people, and the environments we touch. By investing in resilient practices, ethical progress, and continuous improvement, we ensure that growth is not only measurable, but meaningful—strengthening today's success while safeguarding tomorrow's opportunities."
    }
  },
  process: {
    title: "Our Process",
    step1: {
      title: "Consultation",
      description: "We understand your vision and requirements"
    },
    step2: {
      title: "Development",
      description: "Our experts create your perfect blend"
    },
    step3: {
      title: "Production",
      description: "State-of-the-art facilities ensure quality"
    },
    step4: {
      title: "Delivery",
      description: "Timely delivery to your specifications"
    }
  },
  cta: {
    title: "Ready to Start Your Private Label Journey?",
    button: "Contact Us Today"
  }
};
